export enum DROPDOWN_FILTER_SIZES {
    SMALL = 'SMALL',
    LARGE = 'LARGE'
}
